import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {fromEvent} from 'rxjs';
import {AlertService} from '../../../../services/alert/alert.service';
import {ControlReportService} from '../../control-report.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {FcaService} from "../../../fca/fca.service";
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-error-report',
  templateUrl: './error-report.component.html',
  styleUrls: ['./error-report.component.css']
})
export class ErrorReportComponent implements OnInit{
  errorList: any[] = [];

  scrollStatus: any = true;
  scrollTop: any = 0;

  uploadType: string;
  requestType: string;
  generatedId: string;
  tableName: string;
  primaryKey: string;
  uploadRes:any;
  fcaRequestId:any;
  otherParam:string;
  mapData:any;
  pagination: any = {
    paramLimit: 50,
    paramOffset: 0,
  };
  totalPages: any = 0;
  fcaTypeId: any;
  type ?: any;
  @ViewChild('errorTable', {static: true}) _div: ElementRef;

  constructor(
    private alerts: AlertService,
    public bsModalRef: BsModalRef,
    private crs: ControlReportService,
    private fcaService: FcaService) {
  }

  dataMethod:any;
  downloadMethod:any;

  ngOnInit(): void {
    if(this.uploadType=='trp_risk'){
      this.dataMethod = 'trpErrorReport';
      this.downloadMethod = 'downloadTrpErrorReport';
    }else if(this.uploadType=='fca'){
      this.dataMethod = 'fcaErrorReport';
      this.downloadMethod = 'downloadFcaErrorReport';
    }else if(this.uploadType=='special_fca'){
      this.dataMethod = 'sfcaErrorReport';
      this.downloadMethod = 'downloadFcaErrorReport';
    }else if(this.uploadType=='fcaSubmit'){
      this.dataMethod = 'fcaSubmit';
      this.downloadMethod = 'downloadFcaSubmitErrorReport';
    }
    else {
      this.dataMethod = 'mcrErrorReport';
      this.downloadMethod = 'downloadMcrErrorReport';
    }

    this.loadData();
    fromEvent(this._div.nativeElement, 'scroll').subscribe((e: Event) => {
        if (this.scrollTop != (e.target as HTMLElement).scrollTop) {

          this.scrollTop = (e.target as HTMLElement).scrollTop;
          if (((e.target as HTMLElement).scrollHeight - (e.target as HTMLElement).scrollTop === (e.target as HTMLElement).clientHeight) && this.scrollStatus == true && (this.pagination.paramOffset + 50 < this.totalPages)) {
            this.pagination.paramOffset = this.pagination.paramOffset + 50;
            this.loadData()
          } else if ((e.target as HTMLElement).scrollTop == 0 && this.pagination.paramOffset != 0 && this.scrollStatus == true) {
            this.pagination.paramOffset = this.pagination.paramOffset - 50;
            this.loadData()
          }
          this.scrollStatus = true;
        }
    });
  }



  loadData() {
    this.alerts.loading();
    if(this.dataMethod=='sfcaErrorReport'){
      this.resPostProcess(this.uploadRes)
    }
    else if(this.dataMethod=='fcaSubmit'){
      this.resPostProcess(this.uploadRes)
    }
    else if(this.dataMethod=='fcaErrorReport'){
      this.crs[this.dataMethod]({
        generatedId: this.generatedId,
        requestType: this.requestType,
        uploadType: this.uploadType,
        tableName: this.tableName,
        primaryKey: this.primaryKey,
        fcaTypeId:this.fcaTypeId,
        limit: this.pagination.paramLimit,
        offset: this.pagination.paramOffset,
        fcaRequestId: (this.fcaRequestId !== undefined && this.fcaRequestId != null) ? this.fcaRequestId : 0,
      }).subscribe(success => {
          this.resPostProcess(success)
        },
        error => {
          this.alerts.closeAlert();
          this.alerts.toast('error', 'Unable to fetch data. Please try again later. If the problem persists, please contact our support team.')
        }
      );
    }
    else{
      this.crs[this.dataMethod]({
        generatedId: this.generatedId,
        requestType: this.requestType,
        uploadType: this.uploadType,
        tableName: this.tableName,
        primaryKey: this.primaryKey,
        limit: this.pagination.paramLimit,
        offset: this.pagination.paramOffset
      }).subscribe(success => {
          this.resPostProcess(success)
        },
        error => {
          this.alerts.closeAlert();
          this.alerts.toast('error', 'Unable to fetch data. Please try again later. If the problem persists, please contact our support team.')
        }
      );
    }
  }


  resPostProcess(success){
    this.errorList = success['result'];
    this.totalPages = success['totalRow'];
    this.alerts.closeAlert();
    this.scrollStatus = false;
    document.getElementById('errorTable').scrollTo(0, 0);
  }
  //
  downloadErrorReport() {
    this.alerts.loading();
    if(this.dataMethod=='sfcaErrorReport'){
      this.fcaService.downloadSFcaErrorReport({
        generatedId: this.generatedId,
        customSessionId: this.generatedId,
        param:'FCA Special Unassign Invalid Data',
        accountNumber:'Account Number',
        extraParam:'',
        pid:this.fcaRequestId,
        otherParam:this.otherParam
      }).subscribe(res=>{
        if (res) {
          FileSaver.saveAs(new File([res], 'Error Report.csv'));
        } else {
          this.alerts.toast('error', 'No Data Found')
        }
        this.bsModalRef.hide()
        this.alerts.closeAlert()
      },error => {
        this.alerts.closeAlert()
      })
    }else if(this.dataMethod=='fcaErrorReport'||this.dataMethod=='fcaSubmit'){
      console.log(this.mapData)
      this.crs.downloadFcaErrorReport({
        generatedId: this.generatedId,
        requestType: this.requestType,
        uploadType: this.uploadType,
        fcaTypeId:this.fcaTypeId,
        fcaRequestId: (this.fcaRequestId !== undefined && this.fcaRequestId != null) ? this.fcaRequestId : 0,
        limit: this.pagination.paramLimit,
        offset: this.pagination.paramOffset,
        type:this.type,
        mapData:this.mapData ? this.mapData:''
      }).subscribe(
        (data: Blob) => {
          let a = document.createElement('a');
          a.href = URL.createObjectURL(data);
          a.download = 'Error Report.csv';
          a.click();
          a.remove();
          // this.bsModalRef.hide()
          this.alerts.closeAlert();
          this.bsModalRef.hide()
        },
        error => {
          this.alerts.closeAlert();
          this.alerts.toast('error', 'Unable to fetch data. Please try again later. If the problem persists, please contact our support team.')
        }
      );
    } else {
      this.crs[this.downloadMethod]({
        generatedId: this.generatedId,
        requestType: this.requestType,
        uploadType: this.uploadType,
        tableName: this.tableName,
        primaryKey: this.primaryKey,
        type: this.type,
      }).subscribe(res=>{
        let a = document.createElement('a');
        a.href = URL.createObjectURL(res);
        a.download = 'Error Report.csv';
        a.click();
        a.remove();
        this.bsModalRef.hide()
        this.alerts.closeAlert()
      },error => {
        this.alerts.closeAlert()
      })
    }

  }
  close(){
    this.bsModalRef.hide()
  }
}
